module.exports = __webpack_public_path__ + "img/dynamic1.bba6424f.jpg";